module.exports = __webpack_public_path__ + "img/logo.2467f196.png";